/* eslint-disable no-useless-catch */
import { serialize } from '../utils';
import { FindOneOptions } from './common';
import { entityService } from './services';
// #endregion Local Imports

const pathname = '/entity-categories';

export const EntityCategoryApi = {
  filter: async (option: EntityCategoryQuery) => {
    let url = `${pathname}/filter`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findWithEntityForTable: async (option: FindOneOptions) => {
    let url = `${pathname}/find-with-entity`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findWithEntity: async (option: FindWithPartnerEntityQuery) => {
    let url = `${pathname}/entity`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findWithPartnerEntity: async (option: FindWithPartnerEntityQuery) => {
    let url = `${pathname}/entity`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  create: async (body: any) => {
    try {
      const response = await entityService.post(pathname, body);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  createMulti: async (body: CreateMultiEntityCategories) => {
    const url = `${pathname}/multi`;
    try {
      const response = await entityService.post(url, body);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  remove: async (id: string) => {
    const url = `${pathname}/${id}`;
    try {
      const response = await entityService.delete(url);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  removeMulti: async (body: RemoveMultiEntityCategories) => {
    const url = `${pathname}/delete/multi`;
    try {
      const response = await entityService.post(url, body);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  update: async (params: UpdateEntityCategory) => {
    const { id, body } = params;

    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.patch(url, body);

      return response;
    } catch (error) {
      throw error;
    }
  },

  updateStatus: async (params: any) => {
    const { id, body } = params;

    const url = `${pathname}/${id}/status`;

    try {
      const response = await entityService.patch(url, body);

      return response;
    } catch (error) {
      throw error;
    }
  },

  updateSort: async (params: UpdateEntityCategory) => {
    const { id, body } = params;

    const url = `${pathname}/${id}/sort-catgory`;

    try {
      const response = await entityService.patch(url, body);

      return response;
    } catch (error) {
      throw error;
    }
  },
};

export interface EntityCategoryType {
  id: string;
  shortID?: string;
  displayName: string;
  code?: string;
  status: number;
  avatar: string;
  order: number;
  isDefault: boolean;
  createdAt: string;
  productSize?: string;
}

export interface CreateMultiEntityCategories {
  entityCategories: { entityId: string; categoryID: string }[];
}

export interface RemoveMultiEntityCategories {
  entityCategoryIDs: string[];
}

export interface UpdateEntityCategory {
  id: string;
  categoryID: string;
  option: {
    targetType: string;
  };
  body: any;
}

export interface FindWithPartnerEntityQuery {
  id: string;
  isRelationWithEntitySubCategory: boolean;
  isAllStatus: boolean;
}

export interface EntityCategoryQuery {
  order?: any;
  page?: number;
  take?: number;
  skip?: number;
  reserved?: boolean;
  entityID?: string;
  status?: number;
}
